export const SET_USERS = "SET_USERS";
export const DELETE_ALL_USERS = "DELETE_ALL_USERS";
